export default __webpack_public_path__ + "static/media/cineonstudio_hover_change.9cb216a1.svg";